import { render, staticRenderFns } from "./ProductsSummary.vue?vue&type=template&id=3eb00b68&scoped=true&"
import script from "./ProductsSummary.vue?vue&type=script&lang=js&"
export * from "./ProductsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSummary.vue?vue&type=style&index=0&id=3eb00b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb00b68",
  null
  
)

export default component.exports